(() => {
  function initializeSearch() {
    const dialog = document.getElementById('SearchDialog');
    if (!dialog || dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    const input = dialog.querySelector('input[type="search"]');
    const results = dialog.querySelector('#SearchSuggestions');
    const status = dialog.querySelector('[role="status"]');
    const completionRow = dialog.querySelector('.aw-search-completion');
    const completionButton = dialog.querySelector('[data-search-complete]');
    let opener, timer, controller, serial = 0, completion = '';
    const cache = new Map();
    document.querySelectorAll('[data-search-open]').forEach(link => {
      link.addEventListener('click', event => {
        if (!dialog.showModal) return;
        event.preventDefault();
        opener = link;
        if (!dialog.open) dialog.showModal();
        document.documentElement.classList.add('aw-search-lock');
        input.focus();
      });
    });
    function close() {
      clearTimeout(timer);
      controller?.abort();
      serial++;
      dialog.close();
    }
    dialog.querySelector('[data-search-close]').addEventListener('click', close);
    dialog.addEventListener('click', event => {
      if (event.target === dialog && event.clientY > dialog.getBoundingClientRect().bottom) close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('aw-search-lock');
      opener?.focus();
    });
    function render(html, query) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelector('[data-predictive-content]');
      if (!content) throw Error('Missing search results');
      results.replaceChildren(...Array.from(content.childNodes));
      results.querySelectorAll('a').forEach(link => {
        link.setAttribute('role', 'option');
        link.setAttribute('tabindex', '-1');
      });
      const candidates = Array.from(results.querySelectorAll('[data-search-completion]'))
        .map(link => link.dataset.searchCompletion);
      results.querySelectorAll('.aw-search-product > span').forEach(span => {
        const title = span.firstChild?.textContent?.trim() || '';
        candidates.push(title.split('|')[0].trim(), ...title.split(/\s+/));
      });
      completion = candidates.find(term => term && term.toLowerCase().startsWith(query.toLowerCase()) && term.length > query.length) || '';
      completionButton.textContent = completion;
      completionRow.hidden = !completion;
      input.setAttribute('aria-expanded', String(!!results.querySelector('a')));
      status.textContent = '';
    }
    function acceptCompletion() {
      if (!completion) return;
      input.value = completion;
      input.focus();
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    completionButton.addEventListener('click', acceptCompletion);
    input.addEventListener('input', () => {
      clearTimeout(timer);
      controller?.abort();
      const id = ++serial;
      const query = input.value.trim();
      results.replaceChildren();
      completion = '';
      completionRow.hidden = true;
      status.textContent = '';
      input.setAttribute('aria-expanded', 'false');
      results.removeAttribute('aria-busy');
      input.removeAttribute('aria-activedescendant');
      if (!query) return;
      if (cache.has(query.toLowerCase())) {
        render(cache.get(query.toLowerCase()), query);
        return;
      }
      timer = setTimeout(async () => {
        controller = new AbortController();
        status.textContent = dialog.dataset.loading;
        results.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(dialog.dataset.predictiveUrl, document.baseURI);
          url.search = new URLSearchParams({
            q: query,
            'resources[type]': 'query,product,collection',
            'resources[limit]': '6',
            'resources[limit_scope]': 'each',
            section_id: 'predictive-search'
          });
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw Error('Search unavailable');
          const html = await response.text();
          if (id !== serial) return;
          render(html, query);
          if (cache.size > 40) cache.delete(cache.keys().next().value);
          cache.set(query.toLowerCase(), html);
        } catch (error) {
          if (error.name !== 'AbortError' && id === serial) status.textContent = dialog.dataset.error;
        } finally {
          if (id === serial) results.removeAttribute('aria-busy');
        }
      }, 140);
    });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.target === input && event.key === 'Tab' && !event.shiftKey && completion) {
        event.preventDefault();
        acceptCompletion();
        return;
      }
      if (event.key === 'ArrowDown' && event.target === input) {
        const first = results.querySelector('a');
        if (first) { event.preventDefault(); first.focus(); }
      } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        const links = Array.from(results.querySelectorAll('a'));
        const index = links.indexOf(document.activeElement);
        if (index >= 0) {
          event.preventDefault();
          if (event.key === 'ArrowUp' && index === 0) input.focus();
          else links[(index + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length].focus();
        }
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeSearch, { once: true });
  else initializeSearch();
  document.addEventListener('shopify:section:load', initializeSearch);
})();
